<!-- 我的客户 -->
<template>
 <div class="container">
   <div class="top-info">
    <div class="top-info_top">
      <span>
        {{getDayGreetings()}}，{{dataInfo.partnerName}}
      </span>
      <span>
        <!-- 合伙人等级 -->
        {{ $t('app.label.partnerLevel') }} LV{{ dataInfo.partnerLevel }}
      </span>
    </div>
    <div class="top-info_middle">
      <span>
        <!-- 已推荐注册会员数 -->
        {{ $t('app.label.recommendedRegistered') }}
      </span>
      <span class="middle-size">
        {{ dataInfo.clientCount }}
      </span>
    </div>
    <div class="top-info_bottom">
      <div>
        <span>
          <!-- 已入账会员数 -->
         {{ $t('app.label.registeredMember') }}
        </span>
        <span>
          {{ dataInfo.hadDepositCount }}
        </span>
        <div
          v-if="dataInfo.nextLevel"
          class="top-info_bottom-level"
        >
          <div>
            <!-- 距离 -->
            {{ $t('app.label.distance') }} LV{{ dataInfo.nextLevel}}
          </div>
          <div>
            <!-- 还差入账会员 -->
            {{ $t('app.label.stillNeedMember', {
              num: dataInfo.differClientCount
            }) }}
          </div>
        </div>
        <div v-else>{{ $t('app.sentence.maxLevel') }}</div>
      </div>
      <div>
        <span>
          <!-- 推荐累计入账流水 -->
         {{ $t('app.label.recommendCumulativeAccount') }}
        </span>
        <span>
          {{ dataInfo.totalDepositAmount | money }}
        </span>
        <div
          v-if="dataInfo.nextLevel"
        >
          <div>
            <!-- 距离 -->
            {{ $t('app.label.distance') }} LV{{ dataInfo.nextLevel}}
          </div>
          <div>
            {{ $t('app.label.stillNeed') }} ￥{{ dataInfo.differDepositAmount | money }}
          </div>
        </div>
        <div v-else>{{ $t('app.sentence.maxLevel') }}</div>
      </div>
    </div>
   </div>
    <div class="content">
      <div class="list-top">
        <div class="row-item">
          <div
            class="date-btn"
            @click="openModal"
          >
            {{ dateTime | dateYearMon}}
            <vanIcon name="play" size="12"/>
          </div>
          <ActionSheetSelect
            v-model="search.depositStatus"
            :selectList="selectList"
            @selectItem="refresh"
          />
        </div>
        <div class="record-total-num">
          {{ $t('app.sentence.totalRecordNum', {num: total}) }}
        </div>
      </div>
      <vanList
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in list"
          :key="`myClient_${index}`"
          class="list-item row-item__between"
        >
          <div class="col-item">
            <span class="money-num">
              {{ item.memberName }}
              </span>
            <div class="small-thin">
              <span>{{ $t('app.label.memberPhone') }}：</span>
              <span class="deep">{{ item.phone }}</span>
            </div>
            <div class="small-thin">
              <!-- 注册日期 -->
              <span>{{ $t('app.label.registerDate') }}：</span>
              <span class="deep">{{ item.createTime }}</span>
            </div>
          </div>
          <div>
            <div
              class="badge-item"
            >
                <span
                  class="badge-bg"
                  :class="{
                    orange: item.depositStatus === 0
                  }"
                ></span>
                <span class="badge-context">
                  {{ $t(`app.options.credited.${item.depositStatus}`) }}
                </span>
            </div>
          </div>
        </div>
      </vanList>
    </div>

    <DateTimePicker
      v-model ="dateTime"
      ref="dateTimePicker"
      type="year-month"
      title="选择年月"
      :formatter="formatter"
      @confirm="changeTimer"
    />
 </div>
</template>

<script>
import { getDayGreetings } from '@/utils'
import DateTimePicker from '@/components/dateTimePicker'
import { listMixin } from '@/mixins/list'
import ActionSheetSelect from '@/components/actionSheetSelect'
import { apiGet } from '@/services'

export default {
  name: 'my-client-page',
  components: {DateTimePicker, ActionSheetSelect},
  mixins: [listMixin],
  data() {
    return {
      lazyLoading: true,
      api: 'partner/open/client/depositList',
      dataInfo: {},
      search: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        depositStatus: ''
      },
      dateTime: new Date(),
      selectList: [
        {
          name: '已入账', value: 1
        },
        {
          name: '未入账', value: 0
        }
      ],
      tabActive: 'settlementRrecord',
      getDayGreetings
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    // 获取头部个人信息等
    getInfo () {
      apiGet('partner/open/clients').then(res => {
        if (res.code === '0000') {
          this.dataInfo = res.data
        } else {
          this.$handleErr(res.msg)
        }
      })
    },
    refresh() {
      this.data = []
      this.getList()
    },
    // 选择时间
    changeTimer(date) {
      this.search.year = date.getFullYear()
      this.search.month = date.getMonth() + 1
      this.refresh()
    },
    openModal() {
      this.$refs.dateTimePicker.showPopup()
    },
     formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    background: #121212;
    min-height: calc(100vh - 52px);
  }
  .top-info {
    height: 290px;
    background: url(~@/assets/images/myReward/bg.png);
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 12px 16px 26px;
    color: #fff;
    .top-info_top {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      justify-content: space-between;
      padding-bottom: 44px;
    }
    .top-info_middle {
      display: flex;
      flex-direction: column;
      font-size:14px;
      color: rgba(255, 255, 255, .7);
      padding-bottom: 28px;
      span {
        line-height:20px;
        &.middle-size{
          padding-top: 2px;
          font-size:32px;
          color: #fff;
          font-weight:bold;
          line-height:42px;
        }
      }
    }
    .top-info_bottom {
      display: flex;
      flex-direction: row;
      font-size: 12px;
      color: rgba(255, 255, 255, .7);
      & > div {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      span {
        line-height: 18px;
        &:nth-child(2) {
          font-size: 24px;
          padding: 4px;
          color: #fff;
          font-weight: bold;
          line-height: 24px;
        }
      }
    }
  }
  .list-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    .date-btn {
      width:130px;
      height:40px;
      margin-right: 5px;
      background: #737992;
      border-radius:20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 14px;
      /deep/.van-icon-play {
        transform: rotate(90deg);
        padding-bottom: 6px;
      }
    }
    .record-total-num {
      font-size:12px;
      color:rgba(86,95,118,1);
    }
  }
  .list-item {
    background:#282830;
    border-radius:2px;
    display: flex;
    padding: 12px;
    margin-bottom: 10px;
    .money-num {
      font-size: 16px;
      color: rgba(255,255,255,0.86);
      font-weight:bold;
      line-height:26px;
    }
    .small-thin {
      color: rgba(255,255,255,0.60);
      font-size:12px;
      line-height:18px;
      &.deep {
        color: #565F76;
      }
    }
  }
  .content {
    padding: 12px 16px;
  }
  .invite-btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 32px;
    .invite-btn {
      width:223px;
      height:44px;
      background:linear-gradient(90deg,rgba(118,210,255,1) 0%,rgba(31,122,255,1) 100%);
      border-radius:22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:16px;
      color:rgba(255,255,255,1);
    }
  }
</style>
